import {
  ChevronDownIcon,
  InformationCircleIcon,
  LockClosedIcon,
  UserCircleIcon,
  UserIcon,
} from '@heroicons/react/24/solid';
import { useAuth } from '@retainerclub/hooks';
import { useState } from 'react';
import { NavLink } from 'react-router';
import { mobileProfileNavigation } from '../helpers/navLinks';

function MobileNavProfile() {
  const { currentUser, signOut } = useAuth();
  const [open, setOpen] = useState(false);

  if (!currentUser) {
    return (
      <NavLink
        to="/signin"
        className="group -mx-3 flex w-full items-center justify-between gap-x-2.5 rounded-lg px-3 py-2 font-semibold text-base text-gray-900 leading-6 hover:bg-gray-200 focus:outline-none"
      >
        <div className="flex items-center gap-x-2.5">
          <UserCircleIcon
            className="mr-2 size-8 text-rcprimary-400"
            aria-hidden="true"
          />
          <span className="font-normal text-base text-rcprimary-400">
            Sign In
          </span>
        </div>
      </NavLink>
    );
  }

  return (
    <>
      <button
        type="button"
        aria-expanded={open}
        aria-controls="account-mobile-dropdown"
        onClick={() => setOpen((prev) => !prev)}
        className="group -mx-3 flex w-full items-center justify-between gap-x-2.5 rounded-lg px-3 py-2 font-semibold text-base text-gray-900 leading-6 hover:bg-gray-200 focus:outline-none"
      >
        <div className="flex items-center gap-x-2.5">
          <UserIcon className="size-6 text-rcprimary-400" aria-hidden="true" />
          <span>Account</span>
        </div>
        <ChevronDownIcon
          className={`size-5 transition-transform duration-200 ${open ? 'rotate-180' : ''}`}
          aria-hidden="true"
        />
      </button>
      {open && (
        <div
          id="account-mobile-dropdown"
          className="mt-1 space-y-1 border-gray-100 border-l pl-8"
        >
          {mobileProfileNavigation.map((item) => (
            <NavLink
              key={item.id}
              to={item.to}
              className="group flex w-full items-center gap-x-2.5 rounded-lg px-3 py-1 font-normal text-base text-gray-900 leading-6 hover:bg-gray-200"
            >
              {item.icon && <item.icon className="size-5" aria-hidden="true" />}
              {item.name}
            </NavLink>
          ))}
        </div>
      )}

      <NavLink
        to="https://www.retainerclub.com/support"
        className="group -mx-3 flex w-full items-center justify-between gap-x-2.5 rounded-lg px-3 py-2 font-semibold text-base text-gray-900 leading-6 hover:bg-gray-200 focus:outline-none"
      >
        <div className="flex items-center gap-x-2.5">
          <InformationCircleIcon
            className="size-6 text-rcprimary-400"
            aria-hidden="true"
          />
          <span>Support</span>
        </div>
      </NavLink>

      <button
        type="button"
        onClick={signOut}
        className="group -mx-3 flex w-full items-center justify-between gap-x-2.5 rounded-lg px-3 py-2 font-semibold text-base text-gray-900 leading-6 hover:bg-gray-200 focus:outline-none"
      >
        <div className="flex items-center gap-x-2.5">
          <LockClosedIcon
            className="size-6 text-rcprimary-400"
            aria-hidden="true"
          />
          <span>Sign Out</span>
        </div>
      </button>
    </>
  );
}

export default MobileNavProfile;
